import './TokenPairSymbol.less';

import classNames from 'classnames';
import React from 'react';

import MarginIcon from '@/assets/svg/margin_icon.svg?react';
import { CHAIN_ID } from '@/constants/chain';
import { TokenInfo } from '@/types/token';

function TokenPairSymbol({
  baseToken,
  quoteToken,
  isInverse,
  requiredMarginIcon = true,
}: {
  baseToken: Omit<TokenInfo, 'id' | 'chainId'> & { chainId?: CHAIN_ID };
  quoteToken: Omit<TokenInfo, 'id' | 'chainId'> & { chainId?: CHAIN_ID };
  isInverse?: boolean;
  requiredMarginIcon?: boolean;
}): JSX.Element {
  return (
    <span className={classNames('token-pair__symbol')}>
      {isInverse ? (
        <>
          <span className="token-pair__symbol-base">{quoteToken?.symbol}</span>
          {requiredMarginIcon && <MarginIcon className="token-pair__symbol-margin-icon" />}
          <span className="token-pair__symbol-quote">/{baseToken?.symbol}</span>
        </>
      ) : (
        <>
          <span className="token-pair__symbol-base">{baseToken?.symbol}</span>
          <span className="token-pair__symbol-quote">/{quoteToken?.symbol}</span>
          {requiredMarginIcon && <MarginIcon className="token-pair__symbol-margin-icon" />}
        </>
      )}
    </span>
  );
}

export default React.memo(TokenPairSymbol, (prevProps, nextProps) => {
  return (
    prevProps?.baseToken?.address === nextProps?.baseToken?.address &&
    prevProps?.quoteToken.address === nextProps?.quoteToken.address &&
    prevProps?.quoteToken.symbol === nextProps?.quoteToken.symbol &&
    prevProps?.baseToken?.symbol === nextProps?.baseToken?.symbol
  );
});
